<div class="flex flex-col gap-6 animate-in fade-in duration-500">
    <!-- Search and Date Filters -->
    <div class="flex flex-col lg:flex-row items-center justify-between gap-4 p-4 bg-white rounded-2xl shadow-sm border border-slate-100">
        <!-- Search Field -->
        <div class="w-full lg:max-w-xs">
            <p-iconField iconPosition="left" class="w-full">
                <p-inputIcon styleClass="pi pi-search text-slate-400" />
                <input 
                    type="text" 
                    pInputText 
                    [(ngModel)]="searchText" 
                    [placeholder]="'SEARCH' | translate"
                    class="w-full !rounded-xl !py-2.5 !pl-10 !bg-slate-50 !border-none focus:!ring-2 focus:!ring-primary/10 transition-all"
                    (keydown.enter)="applyFilters()">
            </p-iconField>
        </div>

        <!-- Filters Section -->
        <div class="flex flex-wrap items-center gap-3 w-full lg:w-auto">
            <!-- Date Inputs -->
            <div class="flex items-center gap-2">
                <div class="w-32 lg:w-36">
                    <p-datepicker 
                        [(ngModel)]="startDate" 
                        [placeholder]="'START_DATE' | translate"
                        [showIcon]="true"
                        iconDisplay="input"
                        appendTo="body"
                        inputStyleClass="w-full !h-[44px] !border-slate-200 !rounded-xl !text-sm focus:!border-primary focus:!shadow-none"
                        styleClass="w-full">
                    </p-datepicker>
                </div>
                <div class="w-32 lg:w-36">
                    <p-datepicker 
                        [(ngModel)]="endDate" 
                        [placeholder]="'END_DATE' | translate"
                        [showIcon]="true"
                        iconDisplay="input"
                        appendTo="body"
                        inputStyleClass="w-full !h-[44px] !border-slate-200 !rounded-xl !text-sm focus:!border-primary focus:!shadow-none"
                        styleClass="w-full">
                    </p-datepicker>
                </div>
            </div>

            <!-- Action Buttons -->
            <div class="flex items-center gap-2">
                <app-button
                    [label]="'today_filter' | translate"
                    icon="pi pi-calendar"
                    (onClick)="filterToday()"
                    variant="secondary"
                    class="shrink-0">
                </app-button>

                <app-button
                    [label]="'apply_filter' | translate"
                    icon="pi pi-filter"
                    (onClick)="applyFilters()"
                    class="shrink-0">
                </app-button>

                <app-button
                    icon="pi pi-print"
                    (onClick)="printReport()"
                    variant="secondary"
                    [disabled]="loading || blockedRooms.length === 0"
                    class="shrink-0">
                </app-button>

                <p-button
                    *ngIf="hasCustomFilters"
                    icon="pi pi-filter-slash"
                    [rounded]="true"
                    severity="secondary"
                    variant="text"
                    (onClick)="clearFilters()"
                    [pTooltip]="'clear_filters' | translate"
                    tooltipPosition="bottom"
                    styleClass="!h-[44px] !w-[44px] !text-slate-400 hover:!bg-slate-50">
                </p-button>
            </div>
        </div>
    </div>

    <!-- Table Section -->
    <div class="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 overflow-hidden min-h-[500px] flex flex-col">
        <app-prime-table
            [columns]="cols"
            [data]="blockedRooms"
            [loading]="loading"
            [paginator]="blockedRooms.length < pageSize && currentPage === 1 ? false : true"
            [rows]="pageSize"
            [totalRecords]="totalPages * pageSize"
            [lazy]="true"
            (onLazyLoad)="onLazyLoad($event)"
            class="flex-1">
        </app-prime-table>
    </div>
</div>